import { configureStore } from '@reduxjs/toolkit';
import dialogDispositivoReducer from '../redux/reducers/dialogDispositivo-reducer';
import sidebarReducer from '../redux/reducers/sidebar-reducer';
import dataTableDispositivoReducer from '../redux/reducers/dataTableDispositivi-reducer'
import  notificationReducer  from '../redux/reducers/notification-reducer';
import typeCallReducer from '../redux/reducers/typeCallSlice-reducer';
import userReducer from '../redux/reducers/user-reducer';
import dialogCambioPasswordReducer from '../redux/reducers/dialogCambioPassword-reducer';
import dialogUserReducer from "../redux/reducers/dialogUser-reducer";
import rolesReducer from "../redux/reducers/userRolesSlice-reducer";
import dataTableUsersReducer from "../redux/reducers/dataTableUsers-reducer";
import devicesReducer from "../redux/reducers/devices-reducer";

const store = configureStore({
    reducer: {
        sidebar: sidebarReducer,
        dialogDispositivo: dialogDispositivoReducer,
        dataTableDispositivo:  dataTableDispositivoReducer,
        notification: notificationReducer,
        typeCall: typeCallReducer,
        userDate: userReducer,
        dialogCambioPassword: dialogCambioPasswordReducer,
        dialogUser: dialogUserReducer,
        userRoles: rolesReducer,
        dataTableUsers: dataTableUsersReducer,
        devices: devicesReducer
    }
});


export default store; 